@if (hasAccess) {
  <div class="padding">
    <h1 class="left-box">{{ 'common.labels.newReusableParty' | transloco }}</h1>
    <mat-card>
      <mat-card-content>
        <div class="flex-container">
          <mat-form-field appearance="outline" class="form-field grows-to-fill">
            <mat-label>{{ 'common.labels.partyType' | transloco }}</mat-label>
            <mat-select [(ngModel)]="reusableParty.partyTypeID">
              @for (partyType of partyTypes; track partyType) {
                <mat-option [value]="partyType.value">
                  {{ partyType.label | transloco }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (!isBusiness()) {
            <div>
              <mat-checkbox [(ngModel)]="this.reusableParty.isEstate"
                name="is-estate">
                {{ 'common.labels.estate' | transloco }}
              </mat-checkbox>
            </div>
          }
        </div>
        <div class="flex-container">
          @if (isBusiness()) {
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>{{ 'common.labels.name' | transloco }}</mat-label>
              <input matInput name="name" [(ngModel)]="this.reusableParty.busName" [placeholder]="'common.labels.name' | transloco">
            </mat-form-field>
          } @else {
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
              <input matInput name="name" [(ngModel)]="this.reusableParty.firstName" [placeholder]="'common.labels.name' | transloco">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
              <input matInput name="name" [(ngModel)]="this.reusableParty.middleName" [placeholder]="'common.labels.name' | transloco">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
              <input matInput name="name" [(ngModel)]="this.reusableParty.lastName" [placeholder]="'common.labels.name' | transloco">
            </mat-form-field>
          }
        </div>
        <app-client-contact-details-card [contactDetails]="reusableParty.contactDetails!"></app-client-contact-details-card>
        <div class="flex-container">
          <button
            mat-raised-button
            (click)="cancel()"
            class="apply-padding"
            [attr.aria-label]="'common.labels.cancelButton' | transloco"
            [class.spinner]="this.isSaving"
            [disabled]="this.isSaving">
            {{ 'common.buttons.cancel' | transloco }}
          </button>
          <span class="spacer"></span>
          <button
            mat-raised-button
            (click)="saveReusableParty()"
            color="accent"
            class="apply-padding"
            [attr.aria-label]="'common.labels.saveReusablePartyButton' | transloco"
            [class.spinner]="this.isSaving"
            [disabled]="this.isSaving">
            {{ 'common.buttons.save' | transloco }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}